import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const FormPriceTransfer = (props) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      day_price: props.tarif.item.day_price,
      night_price: props.tarif.item.night_price,
      vehicle_available: props.tarif.item.vehicle_available,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    props.tarif.item.night_price = parseFloat(data.night_price);
    props.tarif.item.day_price = parseFloat(data.day_price);
    props.tarif.item.vehicle_available = parseInt(data.vehicle_available);
    await props.changePrice(props.tarif, props.index, data);
    setLoading(false);
  };

  const rule = {
    type: "number",
    placeholder: props.t("day_price"),
    messageError: props.t("price_is__required"),
    className: "input-blue text-dark w-100 p-3 border fw-light ",
    size: "md",
    rules: {
      required: props.t("mandatory"),
    },
  };
  const col = [6, 6, 12];
  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          {["day_price", "night_price", "vehicle_available"].map(
            (field, index) => (
              <Col md={col[index]} key={field} style={{ marginBottom: "12px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginBottom: 5,
                  }}
                >
                  {props.t(field.replace("_price", "")).toUpperCase()}
                </label>
                <IController
                  elment={field}
                  item={rule}
                  control={control}
                  errors={errors}
                  register={register}
                />
              </Col>
            )
          )}
          <Col md="12" className="mt-3">
            <Form
              as="button"
              type="submit"
              className="btn-blue p-3 rounded-3 fw-bold w-100"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></Form>
              ) : (
                props.t("edit")
              )}
            </Form>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormPriceTransfer;
